import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('user');
const LOGIN = define('LOGIN', true);
const LOGOUT = define('LOGOUT', true);
const GET_ME = define('GET_ME', true);

const initialState = {
  loggedIn: false,
  prestine: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN.REJECTED:
      return { loggedIn: false }
    case LOGIN.RESOLVED:
      return { ...action.data.user, loggedIn: true }
    case LOGOUT.RESOLVED:
      return { loggedIn: false }
    case GET_ME.RESOLVED:
      return { ...action.data.user, loggedIn: action.data.isLoggedIn }
    default: return state
  }
};

export const actions = {
  login: ({ email, password }) => ({
    type: LOGIN,
    promise: (async () => {
      const resp = await api.post('/session/login', { email, password });
      if (resp.data.user && !resp.data.user.is_affiliate)
        throw new Error('Not a partner account');
      return resp;
    })(),
    success: 'Logged in successfully',
    error: 'Unable to authenticate'
  }),
  logout: () => ({
    type: LOGOUT,
    promise: api.delete('/session/logout'),
    success: 'Logged out successfully',
    error: 'Unable to logout',
  }),
  getMe: () => ({
    type: GET_ME,
    promise: api.get('/users/me'),
  })
}



// WEBPACK FOOTER //
// ./src/ducks/user.js